import { NgModule } from '@angular/core';
import { TreeModule } from 'primeng/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { AgGridModule } from '@ag-grid-community/angular';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { AuthModule } from 'app/auth/auth.module';
import { CustomTooltipModule } from './directives/tooltip-directive.module';
import { CreatePropertiesModule } from './create-properties/create-properties.module';
import { CheckboxCellComponent } from './cell-renderers/checkbox-cell/checkbox-cell.component';
import { RouteNavLockComponent } from './components/route-nav-lock/route-nav-lock.component';
import { ConfirmDialogCredentialsComponent } from './confirm-dialog-credentials/confirm-dialog-credentials.component';
import { DefaultLoaderComponent } from './default-loader/default-loader.component';
import { EntityNavigatorComponent } from './entity-navigator/entity-navigator.component';
import { DatasourceLinkIconComponent } from './cell-renderers/datasource-link-icon/datasource-link-icon.component';
import { LinkButtonComponent } from './cell-renderers/link-button/link-button.component';
import { CheckboxHeaderCellComponent } from './cell-renderers/checkbox-header-cell/checkbox-header-cell.component';
import { IconComponent } from './cell-renderers/icon/icon.component';
import { NameWithIconComponent } from 'app/shared/cell-renderers/name-with-icon/name-with-icon.component';
import { QualityCodeDialogComponent } from './quality-code-dialog/quality-code-dialog.component';
import { SelectAssetTagComponent } from './select-asset-tag/select-asset-tag.component';
import { ToggleLocationTypeComponent } from './cell-renderers/toggle-location-type/toggle-location-type.component';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { MenuItems } from './menu-items/menu-items';
import { AddTypesComponent } from './add-types/add-types.component';
import { ViewModeDirective } from './editable/view-mode.directive'
import { EditableComponent } from './editable/editable.component'
import { EditModeDirective } from './editable/edit-mode.directive'
import { EditableOnEnterDirective } from './editable/editable-on-enter.directive'

@NgModule({
  imports: [
    CommonModule,
    CreatePropertiesModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatTableModule,
    FlexLayoutModule,
    MatDividerModule,
    MatTabsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    AuthModule,
    MatButtonToggleModule,
    TranslateModule,// translate module
    TreeModule,
    AgGridModule.withComponents([])
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CheckboxCellComponent,
    RouteNavLockComponent,
    ConfirmDialogCredentialsComponent,
    DefaultLoaderComponent,
    EntityNavigatorComponent,
    DatasourceLinkIconComponent,
    LinkButtonComponent,
    CheckboxHeaderCellComponent,
    IconComponent,
    NameWithIconComponent,
    QualityCodeDialogComponent,
    SelectAssetTagComponent,
    ToggleLocationTypeComponent,
    AddTypesComponent,
    EditableComponent,
    ViewModeDirective,
    EditModeDirective,
    EditableOnEnterDirective,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    DefaultLoaderComponent,
    AccordionDirective,
    CustomTooltipModule,
    EditableComponent,
    ViewModeDirective,
    EditModeDirective,
    EditableOnEnterDirective,
  ],
  providers: [MenuItems]
})

export class SharedModule { }